/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_Do_Not_PublishInputs */

const en_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do Not Publish`)
};

const fr_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne pas publier`)
};

const de_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht veröffentlichen`)
};

const it_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non pubblicare`)
};

const ru_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не публиковать`)
};

const es_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No publicar`)
};

const zh_cn2_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请勿发布`)
};

const ja_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開しないでください`)
};

const hi_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशित न करें`)
};

const pt_pt2_work_order_publish_option_do_not_publish = /** @type {(inputs: Work_Order_Publish_Option_Do_Not_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não publicar`)
};

/**
* | output |
* | --- |
* | "Do Not Publish" |
*
* @param {Work_Order_Publish_Option_Do_Not_PublishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_do_not_publish = /** @type {((inputs?: Work_Order_Publish_Option_Do_Not_PublishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_Do_Not_PublishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_option_do_not_publish(inputs)
	if (locale === "de") return de_work_order_publish_option_do_not_publish(inputs)
	if (locale === "it") return it_work_order_publish_option_do_not_publish(inputs)
	if (locale === "ru") return ru_work_order_publish_option_do_not_publish(inputs)
	if (locale === "es") return es_work_order_publish_option_do_not_publish(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_option_do_not_publish(inputs)
	if (locale === "ja") return ja_work_order_publish_option_do_not_publish(inputs)
	if (locale === "hi") return hi_work_order_publish_option_do_not_publish(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_option_do_not_publish(inputs)
	return en_work_order_publish_option_do_not_publish(inputs)
});